import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';

const mixin: ThisTypedComponentOptionsWithRecordProps<Vue, {}, {}, {}, {}, {}, {}, {}> = {
  mounted: function() {
    // Adding the dir attribute by reading the dir attribute value on <html>
    const dir = document.documentElement.getAttribute('dir');

    // It's possible for $el to be a comment element, for example when a v-if is set on the root element
    // and it evaluates to false, so we have to guard against that
    if (this.$el instanceof HTMLElement && dir) {
      this.$el.setAttribute('dir', dir);
    }
  },
};

export default mixin;
